import { render, staticRenderFns } from "./olvido-su-contrasena.vue?vue&type=template&id=38c50181"
import script from "./olvido-su-contrasena.vue?vue&type=script&lang=js"
export * from "./olvido-su-contrasena.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports